import React, { useEffect, useMemo } from 'react';
import dateformat from 'dateformat';
import ReactCanvasConfetti from 'react-canvas-confetti';
import { scrollToElement } from '../../lib/userFunctions';

const canvasStyles = {
    height: '500px',
}

const AuthorMeetingBest = ({ meeting }) => {

    useEffect(() => {
        scrollToElement();
    }, []);
    let animationInstance = null;
    const getInstance = (instance) => {
        animationInstance = instance;
        animateParticle();
    };

    const makeShot = (angle, originX) => {

        animationInstance && animationInstance({
            particleCount: 7,
            angle,
            spread: 170,
            origin: { x: originX, y: 0 },
            colors: ['#bb0000', '#ffffff', '#fdff6c', '#986ba3', '#ec652b', '#e382a5'],
        });
    }

    const animateParticle = () => {
        makeShot(90, Math.random());
        requestAnimationFrame(animateParticle);
    }

    const talkArea = useMemo(() => {
        if (meeting.meetingUser === null) return null;
        return (
            <div className="section talk_area">
                <div className="inner">
                    <div className="roseBox">
                        <div className="left"></div>
                        <div className="right"></div>
                    </div>
                    <div className="talk_box box1">
                        <div className="writer clear">
                            <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                <span className="name">{meeting.meeting.name}</span>
                            </div>
                            <span className="date">{dateformat(meeting.meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meeting.meeting.question1}</div>
                        </div>
                        <div className="child clear">
                            <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                                <span className="name">{meeting.meetingUser?.user?.name || meeting.meetingUser.name}</span>
                            </div>
                            <span className="date">{meeting.meetingUser.answer1Time !== undefined && meeting.meetingUser.answer1Time !== null && dateformat(meeting.meetingUser.answer1Time, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meeting.meetingUser.answer1}</div>
                        </div>
                        {meeting.meetingUser.answerReply1 !== null && meeting.meetingUser.answerReply1 !== '' &&
                            <div className="writer clear">
                                <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                    <span className="name">{meeting.meeting.name}</span>
                                </div>
                                <span className="date">{dateformat(meeting.meetingUser.answerReply1Time, 'yyyy년 mm월 dd일')}</span>
                                <div className="text">{meeting.meetingUser.answerReply1}</div>
                            </div>
                        }

                        <div className="writer clear">
                            <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                <span className="name">{meeting.meeting.name}</span>
                            </div>
                            <span className="date">{dateformat(meeting.meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meeting.meeting.question2}</div>
                        </div>
                        <div className="child clear">
                            <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                                <span className="name">{meeting.meetingUser?.user?.name || meeting.meetingUser.name}</span>
                            </div>
                            <span className="date">{meeting.meetingUser.answer2Time !== undefined && meeting.meetingUser.answer2Time !== null && dateformat(meeting.meetingUser.answer2Time, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meeting.meetingUser.answer2}</div>
                        </div>
                        {meeting.meetingUser.answerReply2 !== null && meeting.meetingUser.answerReply2 !== '' &&
                            <div className="writer clear">
                                <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                    <span className="name">{meeting.meeting.name}</span>
                                </div>
                                <span className="date">{dateformat(meeting.meetingUser.answerReply2Time, 'yyyy년 mm월 dd일')}</span>
                                <div className="text">{meeting.meetingUser.answerReply2}</div>
                            </div>
                        }

                        {meeting.meeting.question3 !== null && meeting.meeting.question3 !== '' &&
                            <>
                                <div className="writer clear">
                                    <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                        <span className="name">{meeting.meeting.name}</span>
                                    </div>
                                    <span className="date">{dateformat(meeting.meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                                    <div className="text">{meeting.meeting.question3}</div>
                                </div>
                                <div className="child clear">
                                    <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                                        <span className="name">{meeting.meetingUser?.user?.name || meeting.meetingUser.name}</span>
                                    </div>
                                    <span className="date">{meeting.meetingUser.answer3Time !== undefined && meeting.meetingUser.answer3Time !== null && dateformat(meeting.meetingUser.answer3Time, 'yyyy년 mm월 dd일')}</span>
                                    <div className="text">{meeting.meetingUser.answer3}</div>
                                </div>
                                {meeting.meetingUser.answerReply3 !== null && meeting.meetingUser.answerReply3 !== '' &&
                                    <div className="writer clear">
                                        <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                            <span className="name">{meeting.meeting.name}</span>
                                        </div>
                                        <span className="date">{dateformat(meeting.meetingUser.answerReply3Time, 'yyyy년 mm월 dd일')}</span>
                                        <div className="text">{meeting.meetingUser.answerReply3}</div>
                                    </div>
                                }
                            </>
                        }
                    </div>

                    <div>
                        <div className="roseBox">
                            <div className="left"></div>
                            <div className="right"></div>
                        </div>
                        <div className="talk_box box2">
                            <div className="child clear">
                                <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                                    <span className="name">{meeting.meetingUser?.user?.name || meeting.meetingUser.name}</span>
                                </div>
                                <span className="date">{meeting.meeting.meetingUser !== null && meeting.meetingUser.questionTime !== null && dateformat(meeting.meetingUser.questionTime, 'yyyy년 mm월 dd일')}</span>
                                <div className="text">&nbsp;{meeting.meetingUser.question}</div>
                            </div>
                            <div className="writer clear">
                                <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                    <span className="name">{meeting.meeting.name}</span>
                                </div>
                                <span className="date">{meeting.meetingUser !== null && meeting.meetingUser.questionAnswerTime !== null && dateformat(meeting.meetingUser.questionAnswerTime, 'yyyy년 mm월 dd일')}</span>
                                <div className="text"><span>{meeting.meetingUser.authorAnswer}</span></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }, [meeting.meeting.createdAt, meeting.meeting.meetingUser, meeting.meeting.name, meeting.meeting.question1, meeting.meeting.question2, meeting.meeting.question3, meeting.meetingUser]);

    return (
        <div className="bestPage">

            <div className="section best_area">
                <div className="front">
                    <img className="title" src={`${process.env.PUBLIC_URL}/images/contents/meeting/reading_king_deco.png`} alt="독서길라잡이가 뽑은 질문왕" />
                    <img className="left" src={`${process.env.PUBLIC_URL}/images/contents/meeting/side_deco_1.png`} alt="왼쪽 커튼" />
                    <img className="right" src={`${process.env.PUBLIC_URL}/images/contents/meeting/side_deco_2.png`} alt="오른쪽 커튼" />
                </div>
                <div className="contentContainer">
                    <div className="content">
                        <div className="trophy">
                            {meeting.meetingUser?.user?.name?.substring(0, 4) || meeting.meetingUser.name}
                        </div>
                    </div>
                    <div className="award">
                        <span>{meeting.meetingUser?.school?.city}</span>
                        <span>{meeting.meetingUser?.school?.name?.replace('초등학교', '초')}</span>
                        <span>{meeting.meetingUser?.grade}학년</span>
                        <span>{meeting.meetingUser?.user?.name || meeting.meetingUser?.name}</span>
                    </div>
                </div>
                <ReactCanvasConfetti refConfetti={getInstance} className="particleContainer" style={canvasStyles} />
            </div>

            {talkArea}
        </div>
    );
}


export default AuthorMeetingBest;